__webpack_require__.p = "/wapp-launcher/";